module.exports = __webpack_public_path__ + "media/site_templates/www.guttercleaning.biz/images/our_services_3-8d79a7e2d868b733ff0bed1acc149585.jpg";